
/**
 * Application configuration with fixed payment values
 */

// Helper to get environment variables
const getEnvVar = (name: string, fallback: string = ''): string => {
  try {
    // Try to get from import.meta.env (Vite's way)
    if (import.meta?.env?.[name]) {
      return import.meta.env[name];
    }
    return fallback;
  } catch (e) {
    console.warn(`Error accessing env var ${name}`, e);
    return fallback;
  }
};

// Creem API configuration from environment variables
export const CREEM_CONFIG = {
  API_KEY: getEnvVar('VITE_CREEM_API_KEY', 'creem_test_5hxo5IyQJ77ZJ6FKFJfhQ3'),
  API_URL: getEnvVar('VITE_CREEM_API_URL', 'https://www.creem.io/test/payment'),
  TEST_MODE: true,
  WEBHOOK_SECRET: getEnvVar('VITE_CREEM_WEBHOOK_SECRET', 'whsec_5K0XvyAW1QOjZSCSUWWvc4')
};

// Payment plans with verified product IDs
export const PAYMENT_PLANS = {
  // $5 plan
  starter: { 
    tokens: 20, 
    productId: 'prod_5KGtXNxf1lxR1oYHGr4OcH',
    price: '$5',
    validity: 30,
    checkoutUrl: 'https://www.creem.io/test/payment/prod_5KGtXNxf1lxR1oYHGr4OcH'
  },
  // $20 plan
  monthly: { 
    tokens: 100, 
    productId: 'prod_5KGtXNxf1lxR1oYHGr4OcH', // Using starter plan for testing
    price: '$20',
    validity: 30,
    checkoutUrl: 'https://www.creem.io/test/payment/prod_5KGtXNxf1lxR1oYHGr4OcH'
  },
  // $45 plan
  team: { 
    tokens: 250, 
    productId: 'prod_5KGtXNxf1lxR1oYHGr4OcH', // Using starter plan for testing
    price: '$45',
    validity: 60,
    checkoutUrl: 'https://www.creem.io/test/payment/prod_5KGtXNxf1lxR1oYHGr4OcH'
  },
  // Free plan for new users
  free: {
    tokens: 2,
    productId: '',
    price: '$0',
    validity: 30,
    checkoutUrl: ''
  }
};

// App configuration with both development and production URLs
export const APP_CONFIG = {
  APP_URL: getEnvVar('VITE_APP_URL', 'https://prompt-assist.com'),
  // Helper to get the correct base URL depending on environment
  getBaseUrl: () => {
    // In browser context
    if (typeof window !== 'undefined') {
      return window.location.origin;
    }
    // In Node.js/server context
    return process.env.NODE_ENV === 'production' 
      ? getEnvVar('VITE_APP_URL', 'https://prompt-assist.com')
      : 'http://localhost:8080';
  }
};

// OpenAI configuration
export const OPENAI_CONFIG = {
  API_KEY: getEnvVar('VITE_OPENAI_API_KEY', ''),
  RAPIDAPI_KEY: getEnvVar('VITE_RAPIDAPI_KEY', ''),
  RAPIDAPI_HOST: getEnvVar('VITE_RAPIDAPI_HOST', ''),
  API_URL: getEnvVar('VITE_API_URL', '')
};

export const WEBHOOK_URL = getEnvVar('VITE_WEBHOOK_URL', 'https://prompt-assist.com/api/webhook');

// Admin configuration
export const ADMIN_CONFIG = {
  INIT_SECRET: getEnvVar('VITE_ADMIN_INIT_SECRET', ''),
  ADMIN_URL: getEnvVar('VITE_ADMIN_URL', '/spark-admin-secure-8a72b9f4'),
  DASHBOARD_URL: getEnvVar('VITE_ADMIN_DASHBOARD_URL', '/spark-dashboard-secure-3e9d5c2a'),
  SESSION_TIMEOUT: parseInt(getEnvVar('VITE_ADMIN_SESSION_TIMEOUT', '3600000')),
  MAX_LOGIN_ATTEMPTS: parseInt(getEnvVar('VITE_MAX_LOGIN_ATTEMPTS', '5')),
  LOCKOUT_DURATION: parseInt(getEnvVar('VITE_LOCKOUT_DURATION', '900000'))
};
